module.exports = __webpack_public_path__ + "7519a24a3f63265990f4d36476725f65.pdf";